// extracted by mini-css-extract-plugin
module.exports = {"general":"style_general__1pxk5","modalLeftRight":"style_modalLeftRight__pJ2-R","modalFade":"style_modalFade__3X3vz","cross":"style_cross__2pkSx","easyZoom":"style_easyZoom__3JWNb"};